import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import debounce from 'lodash.debounce';
import * as ScenarioAPI from '../../services/ScenarioServices';
import { searchClassroomAssignments } from '../../services/AssignmentServices';
import { searchClassroomUsers } from '../../services/ClassroomServices';
import { searchUsers } from '../../services/UserServices';
import styles from './styles/SearchBar.module.css';

const searchConfigs = {
    users: {
        placeholder: 'Search by username or email',
        api: (query, classroomId) => {
        if (classroomId) {
            return searchClassroomUsers(classroomId, query).then((data) => ({ data }));
        }
        return searchUsers(query).then((data) => ({ data }));
        },
        renderResult: (info) => `${info.username} (${info.email})`,
    },
    assignments: {
        placeholder: 'Search assignments',
        api: (query, classroomId) =>
            searchClassroomAssignments(classroomId, query).then((data) => ({ data })),
        renderResult: (info) => info.title,
    },
    scenarios: {
        placeholder: 'Search scenarios',
        api: (query) => ScenarioAPI.searchScenarios(query).then((data) => ({ data })),
        renderResult: (info) =>
        info.searchType === 'user' ? `User: ${info.username} (${info.email})` : `Scenario: ${info.title}`,
    },
    stripeScenariosBuying: {
        placeholder: 'Search scenarios to buy',
        api: (query, _, userId) => axios.post(`${process.env.REACT_APP_API_URL_LOCAL}/api/stripe/stripe-scenario-search`, { searchTerm: query, userId, buying: true }),
        renderResult: (info) =>
        info.searchType === 'user' ? `User: ${info.username} (${info.email})` : `Scenario: ${info.title}`,
    },
    stripeScenariosSelling: {
        placeholder: 'Search your selling scenarios',
        api: (query, _, userId) => axios.post(`${process.env.REACT_APP_API_URL_LOCAL}/api/stripe/stripe-scenario-search`, { searchTerm: query, userId, buying: false }),
        renderResult: (info) =>
        info.searchType === 'user' ? `User: ${info.username} (${info.email})` : `Scenario: ${info.title}`,
    },
    logs: {
        placeholder: 'Search by viewer username or scenario title',
        filterOnly: true,
    },
};


const SearchBar = ({ type, classroomId, userId, setter }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);

    const config = searchConfigs[type];

    const fetchData = async (query) => {
        // filterOnly configs don't fetch a results dropdown; they hand the
        // debounced term to the parent, which owns the actual query.
        if (config.filterOnly) {
            setter(query.trim());
            return;
        }
        if (!query.trim()) {
            setResults([]);
            return;
        }
        try {
            setLoading(true);
            const response = await config.api(query, classroomId, userId);
            setResults(response.data.info || []);
        } catch (error) {
            console.error('Search error:', error);
        } finally {
            setLoading(false);
        }
    };

    const debouncedSearch = useCallback(debounce(fetchData, 400), []);

    useEffect(() => {
        debouncedSearch(searchTerm);
        return debouncedSearch.cancel;
    }, [searchTerm]);

    useEffect(() => {
        if (searchTerm === '') {
            setter(null);
            setResults([]);
        }
    }, [searchTerm, setter]);

    return (
        // <div className={styles.searchContainer}>
        //     <input
        //         type="text"
        //         className={styles.searchInput}
        //         placeholder={config.placeholder}
        //         value={searchTerm}
        //         onChange={(e) => setSearchTerm(e.target.value)}
        //     />
        //     {loading && <p className={styles.loadingText}>Loading...</p>}
        //     <ul className={styles.resultsList}>
        //         {results.map((info) => (
        //             <li key={info._id} className={styles.resultItem}>
        //                 <button className={styles.resultButton} onClick={() => setter(info)}>
        //                     {config.renderResult(info)}
        //                 </button>
        //             </li>
        //         ))}
        //     </ul>
        // </div>
        <div className={styles.searchContainer}>
            <div className={styles.inputWrapper}>
                <input
                    type="text"
                    className={styles.searchInput}
                    placeholder={config.placeholder}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                {searchTerm && (
                    <button
                        type="button"
                        className={styles.clearButton}
                        onClick={() => {
                            setSearchTerm('');
                            setResults([]);
                            setter(null);
                        }}
                    >
                        ×
                    </button>
                )}
            </div>
            {loading && <p className={styles.loadingText}>Loading...</p>}
            <ul className={styles.resultsList}>
                {results.map((info) => (
                    <li key={info._id} className={styles.resultItem}>
                        <button className={styles.resultButton} onClick={() => setter(info)}>
                            {config.renderResult(info)}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default SearchBar;
